export interface IFrequency {
  code: string;
  description: string;
}

export const PaymentFrequency: IFrequency[] = [
  {
    code: 'AP',
    description: 'Yearly'
  },
  {
    code: 'HP',
    description: 'Half yearly'
  },
  {
    code: 'QP',
    description: 'Quarterly'
  },
  {
    code: 'MP',
    description: 'Monthly'
  }
]